// Utilitaires de partage réutilisables (natif via répertoire/apps + SMS)

export const buildSmsHref = (text) => {
  const ua = navigator.userAgent || "";
  const body = encodeURIComponent(text || "");
  // iOS/macOS utilisent "sms:&body=", les autres "sms:?&body="
  return /iPhone|iPad|iPod|Macintosh/i.test(ua) ? `sms:&body=${body}` : `sms:?&body=${body}`;
};

export const openSms = (message, url) => {
  const text = [message, url].filter(Boolean).join("\n");
  window.location.href = buildSmsHref(text);
};

// Ouvre la feuille de partage native (permet SMS, WhatsApp, contacts…) sinon copie le lien.
export const nativeShare = async ({ title, text, url }) => {
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return "shared";
    } catch (e) {
      if (e && e.name === "AbortError") return "aborted";
    }
  }
  try {
    await navigator.clipboard.writeText([text, url].filter(Boolean).join("\n"));
    return "copied";
  } catch {
    return "failed";
  }
};
